export function formatWebhookSecret(secret: string) {
  // Replaces all but the last for characters with a *
  return secret.replace(/.(?=.{4})/g, "*");
}
